export default __webpack_public_path__ + "static/media/empty_cart.1dc38ba2.svg";